(() => {
  const initialize = () => {
    document.querySelectorAll('.qp-fholster-layout').forEach(root => {
      if (root.dataset.fholsterAvailabilityReady) return;
      root.dataset.fholsterAvailabilityReady = 'true';
      const section = root.closest('.main-product');
      const panels = [...root.querySelectorAll('[data-fholster-available]')];
      const selectedPanel = () => {
        const values = [...root.querySelectorAll('.content-column select[name^="options["]')].map(select => select.value);
        return panels.find(panel => JSON.stringify(JSON.parse(panel.dataset.options)) === JSON.stringify(values));
      };
      const sync = () => {
        if (root.hasAttribute('data-qp-purchase-guard') && root.dataset.qpPurchaseState !== 'ready') return;
        const panel = selectedPanel();
        const available = panel?.dataset.fholsterAvailable === 'true';
        section?.querySelectorAll('[data-qp-fholster-cart]').forEach(button => {
          button.disabled = !available;
          button.setAttribute('aria-disabled', String(!available));
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldoutLabel;
        });
      };
      root.addEventListener('change', event => {
        if (event.target.matches('select[name^="options["]')) sync();
      });
      section?.addEventListener('click', event => {
        const button = event.target.closest('button[name="add"]');
        if (button && selectedPanel()?.dataset.fholsterAvailable !== 'true') {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      sync();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
